import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'contact-baseline',
	templateUrl: './contact-baseline.component.html',
	styleUrls: ['./contact-baseline.component.scss'],
})
export class ContactBaselineComponent implements OnInit {
	constructor(public translateService: TranslateService) {}
	@Input() type: 'CGI' | 'LIFE_QUALITY';
	@Input() baseline: {
		level: number;
		levelDescription: string;
		registerDate: string;
	};
	tooltipLabel;
	ngOnInit(): void {
		this.tooltipLabel = this.translateService.instant(
			this.type === 'CGI'
				? 'CONTACT.CGI_TOOLTIP'
				: 'CONTACT.LIFE_QUALITY_TOOLTIP'
		);
	}
}
